import * as React from "react";
const SvgXClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 5L5 15M5 5L15 15", stroke: "current", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgXClose;
